import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString } from "vue"

import { onMounted, ref } from 'vue';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeCounter',
  setup(__props) {

const timer = ref<any>(null);
const time = ref<number>(0);

const resetTimer = (): void => {
  timerStop();
  timerStart();
};

const timerStart = (): void => {
  timer.value = setInterval(() => {
    time.value += 1;
  }, 1000);
};

const timerStop = (): void => {
  clearInterval(0);
  timerReset();
};

const timerReset = (): void => {
  time.value = 0;
};

const secondsInMinutes = (seconds: number): string => moment().startOf('day').seconds(seconds).format('mm:ss');

onMounted(() => {
  resetTimer();
});

return (_ctx: any,_cache: any) => {
  return _toDisplayString(secondsInMinutes(time.value))
}
}

})